import React, {useEffect} from "react";
import {Routes, Route, useLocation} from "react-router-dom";
import {Helmet, HelmetProvider} from "react-helmet-async";
import HomePage from "./HomePage";
import WrappedRoomPage from "./WrappedRoomPage";
import i18n from "./i18n";
import BucketWrappedRoomPage from "./pages/BucketRoom/BucketWrappedRoomPage";
import AboutPoints from "./pages/AboutPoints/AboutPoints";
import AboutUs from "./pages/AboutUs/AboutUs";
import Contacts from "./pages/Contacts/Contacts";
import NotFoundPage from "./pages/404/page404"


const App: React.FC = () => {
    const location = useLocation();


    const canonicalUrl = `${window.location.origin}${location.pathname}`;

    return (
        <HelmetProvider>
            <Helmet>
                <html lang={i18n.language === "ru" ? "ru" : "en"}/>
                <link rel="canonical" href={canonicalUrl}/>
            </Helmet>

            <Routes>
                <Route path="/" element={<HomePage/>}/>
                <Route path="/room/:roomId" element={<WrappedRoomPage/>}/>
                <Route path="/bucket/:roomId" element={<BucketWrappedRoomPage/>}/>
                <Route path="/points" element={<AboutPoints/>}/>
                <Route path="/about" element={<AboutUs/>}/>
                <Route path="/contacts" element={<Contacts/>}/>
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </HelmetProvider>
    );
};

export default App;
